import useEntities from 'new/state/entities/repository/useEntities';

export const useEditBaseFlow = (rootNodeId: string) => {
  const { data: entities } = useEntities();
  const flow = entities.flowNodes[rootNodeId];
  const source = entities.sources[flow?.data_source_id];
  const dataset = entities.dataSets[flow?.data_set_id];
  const resource = source || dataset;

  const projectId = flow?.project_id || null;

  return {
    resource,
    projectId,
  };
};
